import { GridColDef } from "@mui/x-data-grid";

/**
 * Returns the list of field names to include in a DataGrid Excel export.
 *
 * System/UI-only columns are excluded:
 *   - "__detail_panel_toggle__"  MUI detail-panel toggle
 *   - "action" / "actions"      row-action button cells
 *   - "checkbox"                selection checkbox
 *   - "srNo"                    serial-number utility column
 *
 * All other explicitly-defined columns — including "id" — are included so
 * that users can cross-reference exported rows with application records.
 *
 * DQ-8427: The previous implementation also excluded col.field !== "id",
 * which caused the ID column to be absent from the Validation Scoring Config
 * Excel export. That exclusion has been removed.
 */
export function getDataGridExcelExportFields(columns: GridColDef[]): string[] {
  return columns
    .filter(
      (col) =>
        col.field !== "action" &&
        col.field !== "actions" &&
        col.field !== "__detail_panel_toggle__" &&
        col.field !== "checkbox" &&
        col.field !== "srNo",
    )
    .map((col) => col.field);
}
